import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

:root{
   --background: #eff7f9;
   --black:#0a0b10;
   --purple:#803bec;
   --pink:#e5a1f8;
   --white:#fff;
   --nav:#35353f;
   --nav2:#3f3d56;
}


*,*::before,*::after{
    margin:0;
    padding:0;
    box-sizing:border-box;
    font-family: 'Poppins', sans-serif;
}
html{
  ${"" /* overflow-y: scroll; */}
  scroll-behavior:smooth;
  
}
    body,
    html,
    a {
        font-family: 'Poppins', sans-serif;
            }
    body {

        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: var(--background);

        overflow-x: hidden;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin:0;
        padding:0;
    }
    a {
        text-decoration: none;
    }
    button{
        border:none;
        outline:none;
        &:focus-visible{
            outline: 2px dashed var(--purple);
            outline-offset: 3px;
        }
    }
    input:focus-visible,
    textarea:focus-visible,
    a:focus-visible {
        outline: 2px dashed var(--purple);
        outline-offset: 3px;
    }

    img,svg{
        width:100%;
        height:auto;
    }


`;

//  /* Colors */
